export const BOOKING_PROTECTION_DEFAULT_MAX_ORDER_VALUE = 20000
export const BOOKING_PROTECTION_MAX_ORDER_CURRENCY_MAP = {
  AUD: 20000,
  USD: 15000,
  NZD: 22000,
  GBP: 10500,
  SGD: 17900,
  CAD: 18100,
  CNY: 95500,
  EUR: 12300,
  HKD: 103000,
  IDR: 212200000,
  ILS: 49500,
  JPY: 2000000,
  KRW: 18000000,
  MOP: 106000,
  MYR: 62000,
  PHP: 750000,
  QAR: 48200,
  RUB: 1200000,
  SAR: 49600,
  TWD: 428000,
  THB: 480000,
  ZAR: 244600,
  AED: 48600,
  VND: 330000000,
}

export enum BOOKING_PROTECTION_RISK_TYPE_MAP {
  HOTEL = 'Hotel',
  FLIGHT = 'Flight',
  BUNDLED = 'Bundled',
}
